import React from 'react';
import AgencyCreatePaymentMethod from './components/AgencyCreatePaymentMethod.js';
import connect from './connect';
import './assets/AgencyCreatePaymentMethod.css';
import { Elements } from 'react-stripe-elements'; 


const Component = connect(AgencyCreatePaymentMethod);

const ComponentWithElements = (props) => (
  <Elements>
    <Component {...props} />
  </Elements>
);

export default ComponentWithElements;



// WEBPACK FOOTER //
// ./src/routes/AgencyCreatePaymentMethod/index.js